<template>
    <div class="analytics-incorrects__mode">
        <span class="analytics-incorrects__label">{{ $t('analyticsIncorrects.types.' + this.type) }}</span>
        <div v-if="showPreloader" class="analytics-incorrects__mode-preloader"></div>
        <div v-if="showEmptyState" class="analytics-incorrects__empty-state">
            <svg class="analytics-incorrects__empty-state-icon" width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path class="ico-analytics-correctness__incorrects-empty-state-star-1" d="M5.508 12.71c1.195 1.445 2.37 3.81 2.597 5.222.165 1.036.702 1.32.702.373 0-.973 1.324-3.839 2.407-5.21.855-1.08 1.727-1.748 3.244-2.482l2.076-1.004-1.34-.395c-2.644-.78-5.8-4.594-6.288-7.595C8.712.42 8.21.115 8.208 1.195c0 1.052-1.622 4.219-2.868 5.597C4.2 8.054 1.804 9.496.82 9.496c-.293.003.434.476 1.616 1.051 1.303.634 2.514 1.486 3.073 2.163z" fill="#fff"/><path class="ico-analytics-correctness__incorrects-empty-state-star-2" d="M28.268 9.455c.916.406 2.057 2.006 2.079 2.912.007.33.284.01.672-.779.364-.738 1.106-1.64 1.65-2l.991-.659-.925-.479c-.552-.285-1.182-1.004-1.56-1.782l-.633-1.303-.627 1.239c-.345.682-1.047 1.52-1.56 1.859l-.933.619.846.373z" fill="#fff"/><path class="ico-analytics-correctness__incorrects-empty-state-star-3" d="M14.59 20.522c1.806.938 3.386 3.043 3.685 4.909l.194 1.216.351-1.177c.76-2.548 2.341-4.478 4.338-5.293l1.047-.427-1.012-.23c-1.518-.342-3.421-2.414-4.155-4.523-.34-.97-.63-1.501-.643-1.17-.09 2.015-2.728 5.368-4.502 5.724-.828.166-.814.186.697.97z" fill="#fff"/><path class="ico-analytics-correctness__incorrects-empty-state-star-4" d="M42.74 29.822c.121.575.294 1.17.383 1.319.089.15.34-.424.558-1.276.99-3.872 3.43-6.637 6.78-7.684.688-.217.973-.412.635-.412-1.076-.035-3.646-1.51-4.737-2.717-1.315-1.456-2.496-3.75-2.75-5.346-.2-1.245-.718-1.416-.719-.237 0 .96-1.57 4.117-2.673 5.373-1.143 1.302-2.602 2.243-4.3 2.774-.687.217-.972.412-.634.412 1.076.035 3.646 1.51 4.737 2.717 1.212 1.34 2.397 3.555 2.72 5.077z" fill="#fff"/><path class="ico-analytics-correctness__incorrects-empty-state-star-5" d="M27.779 33.05c.38.173.87.718 1.088 1.21l.397.897.51-.839c.28-.46.82-1.054 1.2-1.322l.69-.483-.69-.483c-.38-.266-.948-.905-1.262-1.42-.427-.7-.571-.794-.572-.374 0 .31-.463.999-1.028 1.53l-1.026.97.693.313z" fill="#fff"/><path class="ico-analytics-correctness__incorrects-empty-state-star-6" d="M5.755 43.425c1.619.75 3.216 2.7 3.54 4.321.24 1.198.593 1.157.829-.1.303-1.613 1.815-3.429 3.508-4.213l1.502-.697-.963-.212c-1.407-.31-3.49-2.52-3.932-4.173-.2-.745-.44-1.354-.537-1.354-.096 0-.338.609-.537 1.354-.443 1.654-2.525 3.863-3.933 4.173l-.962.212 1.485.689z" fill="#fff"/><path class="ico-analytics-correctness__incorrects-empty-state-star-7" d="M25.065 47.162c.655 0 2.577 2.32 2.785 3.362l.19.945.407-1.176c.435-1.256 2.046-3.131 2.691-3.131.684 0 .408-.433-.588-.924-.625-.307-1.228-.992-1.71-1.943l-.746-1.468-.751 1.469c-.484.945-1.095 1.638-1.715 1.943-1.007.497-1.267.923-.563.923z" fill="#fff"/></g><defs><clipPath id="clip0_1397_2657"><path fill="#fff" d="M0 0h52v52H0z"/></clipPath></defs></svg>
            <span class="analytics-incorrects__empty-state-text">0 YANLIŞ</span>
        </div>
        <template v-if="showQuestionObject">
            <span class="analytics-incorrects__question-object">
                <span class="analytics-incorrects__question-object-value">{{ curIncorrect.value }}</span>
                <span class="analytics-incorrects__question-object-unit">{{ textQuestionObjectUnit }}</span>
            </span>
            <div class="analytics-incorrects__features">
                <span
                    v-for="feature, key in curIncorrect.features"
                    class="analytics-incorrects__feature">{{ $t(this.i18nNamespace + feature).toLocaleLowerCase('tr') }}</span>
            </div>
            <span class="analytics-incorrects__num-incorrects">{{ curIncorrect.numIncorrects }} YANLIŞ</span>
            <div class="analytics-incorrects__pagination">
                <span class="analytics-incorrects__pagination-text">({{ this.idxCurIncorrect + 1 }}/{{ this.filteredIncorrectsData.length }})</span>
                <button
                    class="analytics-incorrects__btn-next"
                    @click="nextIncorrect">
                    <span class="analytics-incorrects__btn-next-icon"></span>
                </button>
            </div>
        </template>
        <span class="analytics-incorrects__icon"></span>
    </div>
</template>
<script>
    export default {
        props: {
            showPreloader: {
                type: Boolean,
                default: true,
            },
            type: {
                type: String,
                default: 'phonemicVowel',
            },
        },

        data(){
            return {
                idxCurIncorrect: 0,
            };
        },

        computed: {
            filteredIncorrectsData(){
                let selectedFiltertag = this.$store.state.selectedFiltertag.analyticsCorrectness.incorrects.type;
                return this.$store.state.response.analyticsCorrectness.incorrectsData[selectedFiltertag][this.type];
            },

            showEmptyState(){
                if(this.showPreloader){
                    return false;
                }
                return this.filteredIncorrectsData.length === 0;
            },

            showQuestionObject(){
                if(this.showPreloader){
                    return false;
                }
                else if(this.showEmptyState){
                    return false;
                }
                return true;
            },

            curIncorrect(){
                return this.filteredIncorrectsData[this.idxCurIncorrect];
            },

            i18nNamespace(){
                if(this.type.includes('Vowel')){
                    return 'analyticsIncorrects.vowel.';
                }
                else if(this.type.includes('Consonant')){
                    return 'analyticsIncorrects.consonant.';
                }
            },

            textQuestionObjectUnit(){
                if(this.type.includes('phonemic')){
                    return 'SESBİRİM';
                }
                else if(this.type.includes('phonetic')){
                    return 'SESBİRİMCİK';
                }
            }
        },

        watch: {
            '$store.state.selectedFiltertag.analyticsCorrectness.incorrects': {
                handler(nv, ov){
                    this.idxCurIncorrect = 0;
                },
                deep: true
            }
        },

        methods: {
            nextIncorrect(){
                let numCurIncorrect = this.idxCurIncorrect + 1;
                let numIncorrects = this.filteredIncorrectsData.length;
                if(numCurIncorrect === numIncorrects){
                    this.idxCurIncorrect = 0;
                }
                else{
                    this.idxCurIncorrect += 1;
                }
            }
        }
    };
</script>
<style scoped src="@/css/components/analytics-incorrects-mode.css"></style>